export default {
  /**
   * 格式化日期
   * @param date {Date} 日期
   * @param pattern {string} 格式，例："yyyy-MM-dd hh:mm:ss"
   * @returns {String} 返回格式化后的日期，如："2018-01-22 18:04:30"
   */
  format: function (date, pattern) {
    //因为ie11 不支持new Date('2020-10-11 00:00:00')所以先转化成 2020/10/11 00:00:00
    if (typeof (date) == "string") {
      let newStart = date.replace(/-/g, "/")
      date = newStart;
    }
    let newPattern = pattern.replace(/-/g, "/")
    pattern = newPattern;
    var time = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "h+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds(),
      "q+": Math.floor((date.getMonth() + 3) / 3),
      "S+": date.getMilliseconds()
    };
    if (/(y+)/i.test(pattern)) {
      pattern = pattern.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }

    for (var k in time) {
      if (new RegExp("(" + k + ")").test(pattern)) {
        pattern = pattern.replace(RegExp.$1, RegExp.$1.length == 1 ? time[k] : ("00" + time[k]).substr(("" + time[k]).length));
      }
    }
    return pattern;
  },
  /**
   * 将指定时间偏移几小时
   * @param time {String} 指定时间，例："2018-01-24 17:00"
   * @param offset {Number} 偏移量，正数代表加几小时，负数代表减几小时，例：1
   * @param pattern {String} 返回时间的格式，例："yyyy-MM-dd HH:mm"
   * @returns {String} 返回计算后的时间，如："2018-01-24 18:00"
   */
  offsetHours: function (time, offset, pattern) {
    let newPattern = pattern.replace(/-/g, "/")
    pattern = newPattern;
    var date = new Date(Date.parse(time));
    var yyyy = date.getFullYear();
    var MM = date.getMonth();
    var dd = date.getDate();
    var HH = date.getHours() + offset;
    var mm = date.getMinutes();
    var ss = date.getSeconds();
    return this.format(new Date(yyyy, MM, dd, HH, mm, ss), pattern);
  },
  /**
   * 将指定月份偏移几个月
   * @param monthStr {String} 指定月份，例："2018-01"
   * @param offset {Number} 偏移量，负数代表上几个月，正数代表下几个月，例：1
   * @returns {String} 返回计算后的月份，如："2018-02"
   */
  offsetMonths: function (monthStr, offset) {
    var date = new Date(Date.parse(monthStr));
    var year = date.getFullYear();
    var month = date.getMonth();
    var preOrNextMonth = month + offset;
    return this.format(new Date(year, preOrNextMonth), "yyyy/MM");
  },
  /**
   * 获取指定日期是星期几
   * @param date {String} 指定日期,例："2018-01-23"
   * @returns {Number} 返回星期几(1-7)，如：2
   */
  dayOfWeek: function (date) {
    var time = new Date(Date.parse(date));
    var weekday = new Array(7);
    weekday[0] = 7;
    weekday[1] = 1;
    weekday[2] = 2;
    weekday[3] = 3;
    weekday[4] = 4;
    weekday[5] = 5;
    weekday[6] = 6;
    return weekday[time.getDay()];
  },
  /**
   * 获取指定月份有多少天
   * @param monthStr {String} 指定月份：例"2018-01"
   * @returns {number} 返回指定月份有多少天，如：31
   */
  daysInMonth: function (monthStr) {
    var date = new Date(Date.parse(monthStr));
    var year = date.getFullYear();
    var month = date.getMonth();
    if (month == 1) {
      if ((year % 4 == 0 && year % 100 != 0) || year % 400 == 0)
        return 29;
      else
        return 28;
    } else if ((month <= 6 && month % 2 == 0) || (month > 6 && month % 2 == 1))
      return 31;
    else
      return 30;
  },

  /**
   * 获取环期时间段
   * @param {*} type 时间段类型
   * @param {*} startTime 开始时间
   * @param {*} endTime 结束时间
   */
  getLinkRatioDate (type, startTime, endTime) {
    let newStart = startTime;
    //因为ie11 不支持new Date('2020-10-11 00:00:00')所以先转化成 2020/10/11 00:00:00
    if (typeof (startTime) == "string") {
      let newStart = startTime
      startTime = newStart;
    }
    let start = new Date(startTime);
    let end = new Date(endTime);
    if (type === "day") {
      return {
        startTime: this.format(new Date(new Date(start).setDate(new Date(start).getDate() - 1)), "yyyy/MM/dd") + " 00:00:00",
        endTime: newStart
      }
    } else if (type == "week") {
      return {
        startTime: this.format(new Date(start.setDate(start.getDate() - 7)), "yyyy/MM/dd") + " 00:00:00",
        endTime: newStart
      }
    } else if (type === "month") {
      return {
        startTime: this.format(new Date(start.setMonth(start.getMonth() - 1)), "yyyy/MM") + "/01 00:00:00",
        endTime: newStart
      }
    } else if (type === "year") {
      return {
        startTime: this.format(new Date(start.setFullYear(start.getFullYear() - 1)), "yyyy") + "/01/01 00:00:00",
        endTime: newStart
      }
    } else {
      return null
    }
  },
  /**
   * 获取同期时间 去年的今天、去年的今月
   * @param {*} checktime_form //传入的开始时间
   * @param {*} checktime_to //传入的结束时间
   * @param {*} timetype //时间类型
   */
  getCheckBeforeTime (checktime_form, checktime_to, timetype) {
    //因为ie11 不支持new Date('2020-10-11 00:00:00')所以先转化成 2020/10/11 00:00:00
    if (typeof (checktime_form) == "string") {
      let newStart = checktime_form
      checktime_form = newStart;
    }
    if (typeof (checktime_to) == "string") {
      let newEnd = checktime_to
      checktime_to = newEnd;
    }
    let newtiem = {};
    let item = new Date(checktime_form).setFullYear(
      new Date(checktime_form).getFullYear() - 1
    );
    let item_to = new Date(checktime_to).setFullYear(
      new Date(checktime_to).getFullYear() - 1
    );
    let time_from = "",
      time_to = "";
    if (timetype == "day") {
      time_from = this.format(new Date(item), "yyyy-MM-dd") + " 00:00:00";
      time_to = this.format(new Date(item_to), "yyyy-MM-dd") + " 00:00:00";
    } else if (timetype == "month") {
      time_from = this.format(new Date(item), "yyyy-MM") + "/01 00:00:00";
      time_to = this.format(new Date(item_to), "yyyy-MM") + "/01 00:00:00";
    } else {
      time_from = this.format(new Date(item), "yyyy") + "/01/01 00:00:00";
      time_to = this.format(new Date(item_to), "yyyy") + "/01/01 00:00:00";
    }
    newtiem.startTime = time_from;
    newtiem.endTime = time_to;
    return newtiem;
  },
  /**
   * 获取环期时间，昨日，上周，昨月，去年
   * @param {*} checktime 查询的开始时间
   * @param {*} timetype 日、月、年
   */
  getCheckRepeatTime (checktime, timetype) {
    let newtiem = {};
    if (timetype == "day") {
      newtiem.fromDate =
        this.format(
          new Date(new Date(checktime).getTime() - 24 * 60 * 60 * 1000),
          "yyyy-MM-dd"
        ) + " 00:00:00";
    } else if (timetype == "month") {
      let item = new Date(checktime).setMonth(new Date(checktime).getMonth() - 1);
      let time = this.format(new Date(item), "yyyy-MM") + "/01 00:00:00";
      newtiem.fromDate = time;
    } else if (timetype == "week") {
      var now = new Date(checktime); //当前日期
      var nowDayOfWeek = now.getDay(); //今天本周的第几天
      var nowDay = now.getDate(); //当前日
      var nowMonth = now.getMonth(); //当前月
      var nowYear = now.getYear(); //当前年
      nowYear += (nowYear < 2000) ? 1900 : 0; //
      newtiem.fromDate = this.format(new Date(nowYear, nowMonth, nowDay - nowDayOfWeek - 6), "yyyy-MM-dd") + " 00:00:00";
      checktime = this.format(new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1), "yyyy-MM-dd") + " 00:00:00";
    } else {
      let time =
        String(
          Number(this.format(new Date(new Date(checktime).getTime()), "yyyy")) - 1
        ) + "/01/01 00:00:00";
      newtiem.fromDate = time;
    }
    newtiem.toDate = checktime;
    return newtiem;
  },
  /**
   * 获取当前日、周、月、年开始时间
   * @param {*} type 时间类型
   */
  getCurrStartTime (type) {
    let time;
    if (type == "day") {
      time =
        this.format(new Date(new Date().getTime()), "yyyy-MM-dd") + " 00:00:00";
    } else if (type == "month") {
      time =
        this.format(new Date(new Date().getTime()), "yyyy-MM") + "/01 00:00:00";
    } else if (type == "week") {
      let day = new Date().getDay() || 7;
      time = this.format(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1 - day))
    } else {
      time =
        this.format(new Date(new Date().getTime()), "yyyy") + "/01/01 00:00:00";
    }
    return time;
  },
  /**
   * 创建x轴数据
   * @param {*} timeType 时间类型
   * @param {*} startTime 开始时间
   * @param {*} endTime 结束时间
   */
  createXAxisObj (timeType, startTime, endTime) {
    //因为ie11 不支持new Date('2020-10-11 00:00:00')所以先转化成 2020/10/11 00:00:00
    if (typeof (startTime) == "string") {
      let newStart = startTime
      startTime = newStart;
    }
    if (typeof (endTime) == "string") {
      let newEnd = endTime
      endTime = newEnd;
    }
    let start = new Date(startTime);
    let end = new Date(endTime);
    let differ = end.getTime() - start.getTime();
    let format = "hh时";
    if (timeType == "day") {
      format = "hh时"
    } else if (timeType == "month") {
      format = "dd日hh时"
    } else {
      format = "MM月dd日hh时"
    }
    const differHour = differ / (3600 * 1000)
    let timeObj = {}
    for (let i = 0; i < differHour; i++) {
      if (i !== 0) {
        start.setHours(start.getHours() + 1)
      }
      timeObj[this.format(start, format)] = "-"
    }
    return {
      timeObj: timeObj,
      format: format
    };
  },
  /**
   * 创建x轴数据2
   * @param {*} timeType 时间类型
   * @param {*} startTime 开始时间
   * @param {*} endTime 结束时间
   */
  createXAxisObj2 (timeType, startTime, endTime) {
    //因为ie11 不支持new Date('2020-10-11 00:00:00')所以先转化成 2020/10/11 00:00:00
    if (typeof (startTime) == "string") {
      let newStart = startTime
      startTime = newStart;
    }
    if (typeof (endTime) == "string") {
      let newEnd = endTime
      endTime = newEnd;
    }
    let start = new Date(startTime);
    let end = new Date(endTime);
    let differ = end.getTime() - start.getTime();
    let timeObj = {}
    let format = "hh时";
    if (timeType == "day") {
      format = "hh时"
      const differHour = differ / (3600 * 1000)
      for (let i = 0; i < differHour; i++) {
        if (i !== 0) {
          start.setHours(start.getHours() + 1)
        }
        timeObj[this.format(start, format)] = "-"
      }
    } else if (timeType == "month" || timeType == "week") {
      format = "dd日"
      const differHour = differ / (3600 * 1000 * 24)
      for (let i = 0; i < differHour; i++) {
        if (i !== 0) {
          start.setDate(start.getDate() + 1)
        }
        timeObj[this.format(start, format)] = "-"
      }
    } else if (timeType == "year") {
      format = "MM月"
      for (let i = 0; i < 12; i++) {
        if (i !== 0) {
          start.setMonth(start.getMonth() + 1)
        }
        timeObj[this.format(start, format)] = "-"
      }
    } else {
      format = "MM月dd日hh时"
    }

    return {
      timeObj: timeObj,
      format: format
    };
  },

  createXDataForTime (timeType, startTime, endTime) {
    let data = []
    const startTimeDate = new Date(startTime)
    const endTimeDate = new Date(endTime)
    let dynamic = new Date(startTime)
    switch (timeType) {
      case 'hour':
        while (dynamic.getTime() < endTimeDate.getTime()) {
          data.push(new Date(dynamic.getTime()))
          dynamic = new Date(dynamic.setHours(dynamic.getHours() + 1))
        }
        break;
      case 'day':
        while (dynamic.getTime() < endTimeDate.getTime()) {
          data.push(new Date(dynamic.getTime()))
          dynamic = new Date(dynamic.setDate(dynamic.getDate() + 1))
        }
        break;
      case 'month':
        while (dynamic.getTime() < endTimeDate.getTime()) {
          data.push(new Date(dynamic.getTime()))
          dynamic = new Date(dynamic.setMonth(dynamic.getMonth() + 1))
        }
        break;
      case 'year':
        while (dynamic.getTime() < endTimeDate.getTime()) {
          data.push(new Date(dynamic.getTime()))
         
          dynamic = new Date(dynamic.setFullYear(dynamic.getFullYear() + 1))
        }
        break;
    }
    return data
  }
    

}